// extracted by mini-css-extract-plugin
module.exports = {"guarantee_wrapper":"Guarantee_theme1_guarantee_wrapper__nVRx7","badge_wrapper":"Guarantee_theme1_badge_wrapper__RD8iM","text_wrapper":"Guarantee_theme1_text_wrapper__bcVpK"};